/**
 * Geolocation Service Config
 * @author Rhys Lloyd
 */

//noinspection JSValidateTypes
/**
 * @type {google.maps.GeocoderComponentRestrictions}
 */
export const COMPONENT_RESTRICTIONS = {
	country: 'au',
};



// WEBPACK FOOTER //
// ./project/client/src/core/services/geolocation/config.js